import React, { FC } from "react";
import { T } from "services/lang/LanguageService";
import { InputNumber } from "primereact/inputnumber";
import { DialIndicatorEditorProps } from "./DialIndicatorTypes";

const DialIndicatorOptionsEditor: FC<DialIndicatorEditorProps> = ({ config, onConfigChange }) => {
  return (
    <div className="flex flex-row gap-2 w-12">
      <div className="flex flex-column gap-2 w-2">
        <label htmlFor="updateFrequency">{T("load-conf.update-frequency")}</label>
        <div className="p-inputgroup w-full">
          <InputNumber
            id="updateFrequency"
            value={config.updateFrequency as number}
            onValueChange={e => onConfigChange({ ...config, updateFrequency: e.value ?? 0 })}
          />
          <span className="p-inputgroup-addon">s</span>
        </div>
      </div>
    </div>
  );
};

export default DialIndicatorOptionsEditor;
